module.exports = __webpack_public_path__ + "static/media/SicilianExpedition.6538c92e.jpg";